import { Box, Typography } from '@mui/material';

type ForgeWordmarkProps = {
  centered?: boolean;
};

/** FORGE, underlined in the sign-in page's cyan glow (#2fd0e6) fading to the primary colour. */
const ForgeWordmark = ({ centered = false }: ForgeWordmarkProps) => (
  <Box
    sx={{
      display: 'inline-flex',
      flexDirection: 'column',
      alignItems: centered ? 'center' : 'flex-start',
      gap: 0.75
    }}
  >
    <Typography
      component="div"
      sx={{
        fontSize: '1.4rem',
        fontWeight: 800,
        lineHeight: 1.1,
        letterSpacing: '0.2em',
        // Offset the trailing letter-space so a centred wordmark sits optically centred.
        textIndent: centered ? '0.2em' : 0
      }}
    >
      FORGE
    </Typography>
    <Box
      aria-hidden
      sx={{
        width: 28,
        height: 3,
        borderRadius: '2px',
        background: (theme) => `linear-gradient(90deg, #2fd0e6, ${theme.palette.primary.main})`
      }}
    />
  </Box>
);

export default ForgeWordmark;
